import type { MotifEffect } from '../../../data/full/tatoue';
import type { SkillModule } from '../../skills/types';
import { statValue } from '../../stats';
import { layZone } from '../../zones';

export const motif: SkillModule<MotifEffect> = {
  cast(ctx, player, effect, _input, power) {
    layZone(ctx, player, effect.zone, {
      x: player.x + player.aim.x * effect.distance,
      y: player.y + player.aim.y * effect.distance,
      power,
      radius: statValue(player, 'skillRadiusMul', effect.zone.radius),
    });
  },
};
